/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  AsoRequestCreateRequest,
  AsoRequestResponseCollectionResponse,
  AsoRequestResponseDataResponse,
  AsoRequestUpdateRequest,
  AsoScenarioComputeMode,
  AsoScenarioConfigurationDataResponse,
  AsoScenarioConfigurationPatchRequest,
  AsoScenarioCreateRequest,
  AsoScenarioMinLayerCreateRequest,
  AsoScenarioMinLayerResponseCollectionResponse,
  AsoScenarioMinLayerResponseDataResponse,
  AsoScenarioMinLayerUpdateRequest,
  AsoScenarioResponseCollectionResponse,
  AsoScenarioResponseDataResponse,
  AsoScenarioScopeResponseCollectionResponse,
  AsoScenarioScopeResponseDataResponse,
  AsoScenarioScopeSourceResponseDataResponse,
  AsoScenarioScopeSourceUpdateRequest,
  AsoScenarioScopeTargetResponseDataResponse,
  AsoScenarioScopeTargetUpdateRequest,
  AsoScenarioScopeUpdateRequest,
  AsoScenarioStoreTierConfigurationPatchRequest,
  AsoScenarioStoreTierConfigurationResponseCollectionResponse,
  AsoScenarioStoreTierForceRequest,
  AsoScenarioStoreTierResponseCollectionResponse,
  AsoScenarioStoreTierSettingsResponseDataResponse,
  AsoScenarioStoreTierSettingsUpdateRequest,
  AsoScenarioStoreTierType,
  AsoScenarioStoreTierUpdateRequest,
  AsoScenarioUpdateRequest,
  ErrorResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Aso<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags AsoRequest
   * @name RequestsCreate
   * @request POST:/Aso/Requests
   * @response `200` `AsoRequestResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  requestsCreate = (data: AsoRequestCreateRequest, params: RequestParams = {}) =>
    this.http.request<AsoRequestResponseDataResponse, ErrorResponse>({
      path: `/Aso/Requests`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoRequest
   * @name GetAsoRequests
   * @request GET:/Aso/Requests
   * @response `200` `AsoRequestResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAsoRequests = (params: RequestParams = {}) =>
    this.http.request<AsoRequestResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Requests`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoRequest
   * @name RequestsPartialUpdate
   * @request PATCH:/Aso/Requests/{id}
   * @response `200` `AsoRequestResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  requestsPartialUpdate = (id: number, data: AsoRequestUpdateRequest, params: RequestParams = {}) =>
    this.http.request<AsoRequestResponseDataResponse, ErrorResponse>({
      path: `/Aso/Requests/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoRequest
   * @name RequestsDelete
   * @request DELETE:/Aso/Requests/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  requestsDelete = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Requests/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosList
   * @request GET:/Aso/Scenarios
   * @response `200` `AsoScenarioResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosList = (params: RequestParams = {}) =>
    this.http.request<AsoScenarioResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Scenarios`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosCreate
   * @request POST:/Aso/Scenarios
   * @response `200` `AsoScenarioResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosCreate = (data: AsoScenarioCreateRequest, params: RequestParams = {}) =>
    this.http.request<AsoScenarioResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosDetail
   * @request GET:/Aso/Scenarios/{id}
   * @response `200` `AsoScenarioResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosDetail = (id: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosPartialUpdate
   * @request PATCH:/Aso/Scenarios/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosPartialUpdate = (
    id: number,
    data: AsoScenarioUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosDelete
   * @request DELETE:/Aso/Scenarios/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosDelete = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/Scopes
   * @response `200` `AsoScenarioScopeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioScopeResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesCreate
   * @request POST:/Aso/Scenarios/{asoScenarioId}/Scopes
   * @response `200` `AsoScenarioScopeResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesCreate = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioScopeResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}
   * @response `200` `AsoScenarioScopeResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesPartialUpdate = (
    asoScenarioId: number,
    scopeId: number,
    data: AsoScenarioScopeUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AsoScenarioScopeResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesDelete
   * @request DELETE:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesDelete = (asoScenarioId: number, scopeId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesSourcePartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}/Source
   * @response `200` `AsoScenarioScopeSourceResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesSourcePartialUpdate = (
    asoScenarioId: number,
    scopeId: number,
    data: AsoScenarioScopeSourceUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AsoScenarioScopeSourceResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}/Source`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesTargetsCreate
   * @request POST:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}/Targets
   * @response `200` `AsoScenarioScopeTargetResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesTargetsCreate = (
    asoScenarioId: number,
    scopeId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<AsoScenarioScopeTargetResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}/Targets`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesTargetsPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}/Targets/{targetId}
   * @response `200` `AsoScenarioScopeTargetResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesTargetsPartialUpdate = (
    asoScenarioId: number,
    scopeId: number,
    targetId: number,
    data: AsoScenarioScopeTargetUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AsoScenarioScopeTargetResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}/Targets/${targetId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosScopesTargetsDelete
   * @request DELETE:/Aso/Scenarios/{asoScenarioId}/Scopes/{scopeId}/Targets/{targetId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosScopesTargetsDelete = (
    asoScenarioId: number,
    scopeId: number,
    targetId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Scopes/${scopeId}/Targets/${targetId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosMinLayersList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/MinLayers
   * @response `200` `AsoScenarioMinLayerResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosMinLayersList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioMinLayerResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/MinLayers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosMinLayersCreate
   * @request POST:/Aso/Scenarios/{asoScenarioId}/MinLayers
   * @response `200` `AsoScenarioMinLayerResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosMinLayersCreate = (
    asoScenarioId: number,
    data: AsoScenarioMinLayerCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AsoScenarioMinLayerResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/MinLayers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosMinLayersPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/MinLayers/{minLayerId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosMinLayersPartialUpdate = (
    asoScenarioId: number,
    minLayerId: number,
    data: AsoScenarioMinLayerUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/MinLayers/${minLayerId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosMinLayersDelete
   * @request DELETE:/Aso/Scenarios/{asoScenarioId}/MinLayers/{minLayerId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosMinLayersDelete = (
    asoScenarioId: number,
    minLayerId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/MinLayers/${minLayerId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTiersList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/StoreTiers
   * @response `200` `AsoScenarioStoreTierResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTiersList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioStoreTierResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTiers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ForceAsoScenarioStoreTiers
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/StoreTiers
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  forceAsoScenarioStoreTiers = (
    asoScenarioId: number,
    data: AsoScenarioStoreTierForceRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTiers`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name RecomputeAsoScenarioStoreTiers
   * @request PUT:/Aso/Scenarios/{asoScenarioId}/StoreTiers
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  recomputeAsoScenarioStoreTiers = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTiers`,
      method: 'PUT',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTiersPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/StoreTiers/{storeId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTiersPartialUpdate = (
    asoScenarioId: number,
    storeId: number,
    data: AsoScenarioStoreTierUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTiers/${storeId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTierSettingsList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/StoreTierSettings
   * @response `200` `AsoScenarioStoreTierSettingsResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTierSettingsList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioStoreTierSettingsResponseDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTierSettings`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTierSettingsPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/StoreTierSettings
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTierSettingsPartialUpdate = (
    asoScenarioId: number,
    data: AsoScenarioStoreTierSettingsUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTierSettings`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTierConfigurationsList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/StoreTierConfigurations
   * @response `200` `AsoScenarioStoreTierConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTierConfigurationsList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioStoreTierConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTierConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosStoreTierConfigurationsPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/StoreTierConfigurations/{storeTier}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosStoreTierConfigurationsPartialUpdate = (
    asoScenarioId: number,
    storeTier: AsoScenarioStoreTierType,
    data: AsoScenarioStoreTierConfigurationPatchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/StoreTierConfigurations/${storeTier}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosConfigurationList
   * @request GET:/Aso/Scenarios/{asoScenarioId}/Configuration
   * @response `200` `AsoScenarioConfigurationDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosConfigurationList = (asoScenarioId: number, params: RequestParams = {}) =>
    this.http.request<AsoScenarioConfigurationDataResponse, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Configuration`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ScenariosConfigurationPartialUpdate
   * @request PATCH:/Aso/Scenarios/{asoScenarioId}/Configuration
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  scenariosConfigurationPartialUpdate = (
    asoScenarioId: number,
    data: AsoScenarioConfigurationPatchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Configuration`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AsoScenario
   * @name ComputeAsoScenario
   * @request POST:/Aso/Scenarios/{asoScenarioId}/Compute
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  computeAsoScenario = (
    asoScenarioId: number,
    query?: {
      mode?: AsoScenarioComputeMode;
      /** @format int32 */
      calculationId?: number;
      /** @format int32 */
      entityListId?: number;
      title?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Aso/Scenarios/${asoScenarioId}/Compute`,
      method: 'POST',
      query: query,
      ...params,
    });
}
